export function resolveExpertiseAnchor(hash) {
    if (!hash || hash === '#') return null;
    let id;
    try {
        id = decodeURIComponent(hash.slice(1));
    } catch {
        return null;
    }
    const target = document.getElementById(id) || document.getElementById(id.replace(/^expertise-/, ''));
    return target?.matches('.expertise-sector-sec') ? target : null;
}

const scrollToTarget = (target, behavior) => {
    const headerOffset = document.querySelector('.header')?.offsetHeight || 90;
    window.scrollTo({
        top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerOffset),
        behavior,
    });
    window.history.replaceState(null, '', `#${target.id}`);
};

export function initExpertiseAnchors() {
    if (window.expertiseAnchorsInitialized) return;
    window.expertiseAnchorsInitialized = true;
    document.addEventListener('click', (event) => {
        const link = event.target.closest?.('[data-expertise-anchor]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = resolveExpertiseAnchor(link.hash);
        if (!target) return;
        event.preventDefault();
        scrollToTarget(target, 'smooth');
    });
    const scrollFromHash = () => {
        const target = resolveExpertiseAnchor(window.location.hash);
        if (target) window.requestAnimationFrame(() => scrollToTarget(target, 'instant'));
    };
    window.addEventListener('hashchange', scrollFromHash);
    if (document.readyState === 'complete') scrollFromHash();
    else window.addEventListener('load', scrollFromHash, { once: true });
}

if (typeof document !== 'undefined') initExpertiseAnchors();
